// src/config/api.ts
export const API_CONFIG = {
  BASE_URL: 'https://api.xavear.de',
  SPOTIFY: {
    CLIENT_ID: process.env.REACT_APP_SPOTIFY_CLIENT_ID || '',
    REDIRECT_URI: process.env.REACT_APP_SPOTIFY_REDIRECT_URI || 'http://localhost:3000/callback',
    AUTH_ENDPOINT: 'https://accounts.spotify.com/authorize',
    TOKEN_ENDPOINT: 'https://accounts.spotify.com/api/token'
  },
  ENDPOINTS: {
    AUTH: {
      SPOTIFY_CALLBACK: '/api/auth/spotify-callback',
      REFRESH_TOKEN: '/api/auth/refresh-token'
    },
    DASHBOARD: {
      SUMMARY: '/api/dashboard/summary',
      SCORE_HISTORY: '/api/dashboard/score-history',
      ENGAGEMENT_METRICS: '/api/dashboard/engagement-metrics',
      SIMILAR_ARTISTS: '/api/dashboard/similar-artists'
    },
    ARTIST: {
      DETAILS: (id: string) => `/api/artist/${id}`,
      SONGS: (id: string) => `/api/artist/${id}/songs`,
      METRICS: (id: string) => `/api/artist/${id}/metrics`,
      LINK: (id: string) => `/api/artist/${id}/link`,
      UNLINK: (id: string) => `/api/artist/${id}/unlink`,
      LINKED_ARTISTS: '/api/artist/linked'
    },
    SPOTIFY: {
      ARTIST_PROFILE: '/api/spotify/artist-profile',
      ARTIST_STATS: '/api/spotify/artist-stats',
      FETCH_METRICS: '/api/spotify/fetch-metrics',
      SEARCH_ARTISTS: '/api/spotify/search-artists'
    }
  }
};

// Helper function to generate complete API URLs
export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};